module.exports = __webpack_public_path__ + "static/img/introduceBTypeBIcon3.8707bf2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/introduceBTypeBIcon3.png
// module id = vfpN
// module chunks = 0